import { useAppSelector } from "@/store/hooks";
import { FormEvent, ReactNode, useEffect, useState } from "react";
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap";
import styles from "./style.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";
import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import { ClientStatusRowData, InterestConfigType, normalizeClientStatusRow } from "@utils/DocumentStatus";
import moment from "moment";
import { DocumentsEntryType } from "../DocumentStatusList";
import { formatMoneyValue } from "@utils/Currency";

type InvoiceAsignementSearchFormProps = {
  onInvoiceSelect: (invoice: ClientStatusRowData) => void,
  clientId: string
};

const InvoiceAsignementSearchForm = (props: InvoiceAsignementSearchFormProps) => {
  const { onInvoiceSelect, clientId } = props;
  const [invoices, setInvoices] = useState<ClientStatusRowData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [filterText, setFilterText] = useState<string | boolean>(false);
  const suscriptionData = useAppSelector(state => state.suscription?.suscription)

  useEffect(() => {
  }, [])


  useEffect(() => {
    if (filterText !== false) {
      const run = async () => {
        const invoice = await fetchInvoices();
        setInvoices(invoice);
      }
      run()
    }
  }, [filterText]);

  const fetchInvoices = async (): Promise<ClientStatusRowData[]> => {
    setIsLoading(true)
    try {
      const invoiceNumber = Number(filterText || 0);
      const interestConfig: InterestConfigType = {
        interestOnDue: Number(suscriptionData?.interest_on_due || 0),
        isInterestOnDue: suscriptionData?.is_interest_on_due || false,
      }

      const { items: data } = await InvoiceApi.fetchAllByInvoiceNumber(invoiceNumber)

      if (data.length > 0 && !checkIfInvoiceValid(data)) {
        return []
      }
      const today = moment();

      return await Promise.all(data.map(r => {
        const entry: DocumentsEntryType = {
          data: r,
          kind: "invoice"
        }
        return entry
      }).map(r => normalizeClientStatusRow(today.format("YYYY-MM-DD"), r, interestConfig)))
    } finally {
      setIsLoading(false)
    }
  }

  const checkIfInvoiceValid = (invoices: InvoiceDataType[]): boolean => {
    if (!invoices.some(i => i.status == "pendiente")) {
      showAlert("danger", `La factura #${filterText} se encuentra pagada o anulada, por lo cual no puede ser utilizar para asignar esta nota de credito`)
      return false
    } else if (!invoices.some(i => i.clientId == clientId)) {
      showAlert("danger", `La factura #${filterText} no pertenece al mismo cliente al que se le realizo la nota de credito, por lo cual no puede ser utilizar para asignar esta nota de credito`)
      return false
    }
    return true
  }

  const search = (e: FormEvent) => {
    e.preventDefault();
    setFilterText(inputValue);
  }

  const clearSearchForm = () => {
    setInputValue("");
    setFilterText("");
  }

  const renderFilterForm = (): ReactNode | null => {
    return (
      <>
        <Form onSubmit={(e) => search(e)}>
          <Row className="row-cols-lg-auto g-1 align-items-center">
            <Col>
              <Label className="g-0 pe-3"
                for="general-search-criteria"
              >
                Numero Factura
              </Label>
            </Col>
            <Col lg="5">
              <Input
                id="general-search-criteria"
                name="filter"
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Col>
            <Col>
              <Button className="me-1" color="primary" type="submit">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Button>
              <Button color="danger" type="button" onClick={() => clearSearchForm()}>
                <FontAwesomeIcon icon={faXmark} />
              </Button>
            </Col>
          </Row>
        </Form>
        <hr />
      </>
    )
  }

  const selectInvoice = (invoice: ClientStatusRowData) => {
    onInvoiceSelect(invoice);
  }

  const renderInvoice = (): ReactNode[] => {
    return invoices.map(i => {
      const date = moment(i.fecha, "YYYY-MM-DD")
      const formatDate = date.format("DD-MM-YYYY")
      const currencyId = Number(i.currency.currency_id || 1);

      return (
        <tr>
          <td className="col-2">
            {i.numero}
          </td>
          <td className="col-4">
            {i.nombreFacturacion}
          </td>
          <td className="col-2 text-center">
            {formatDate}
          </td>
          <td className="col-2 text-center">
            <td>{formatMoneyValue(i.saldo, currencyId)}</td>
          </td>
          <td className="col-3">
            <Button type="button" size="sm" onClick={() => { selectInvoice(i) }} color="primary"><FontAwesomeIcon className="me-2" icon={faCheck} />  Seleccionar</Button>
          </td>
        </tr>
      )
    })
  }

  return (
    <>
      <Row>
        <Col>
          {renderFilterForm()}
        </Col>
      </Row>
      <Table className={styles.productTable} size="sm">
        <thead>
          <tr>
            <th>
              # Factura
            </th>
            <th>
              Nombre Facturacion
            </th>
            <th className="text-center">
              Fecha
            </th>
            <th className="text-center">
              Saldo
            </th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
          {renderInvoice()}
        </tbody>
      </Table>

      <LoadingScreen isLoading={isLoading} />
    </>
  )
}

export default InvoiceAsignementSearchForm;